import CancelReasonFeedbackRoot from '../../components/pages/CancelReasonFeedback';
import { FullHeightOnly } from '../../components/shared/Grid';
import TemplateCenter from '../../layout/TemplateCenter';

const CancelReasonFeedback = () => {
  return (
    <TemplateCenter>
      <FullHeightOnly>
        <CancelReasonFeedbackRoot />
      </FullHeightOnly>
    </TemplateCenter>
  );
};

export default CancelReasonFeedback;
